import { createContext, useContext } from "react";
import type { RatingStats } from "@/lib/ratingStats";

type SsrDataContextValue = {
  initialRatingStats: RatingStats | null;
};

const SsrDataContext = createContext<SsrDataContextValue>({
  initialRatingStats: null,
});

type SsrDataProviderProps = {
  initialRatingStats?: RatingStats | null;
  children: React.ReactNode;
};

export function SsrDataProvider({
  initialRatingStats = null,
  children,
}: SsrDataProviderProps) {
  return (
    <SsrDataContext.Provider value={{ initialRatingStats }}>
      {children}
    </SsrDataContext.Provider>
  );
}

export function useSsrData() {
  return useContext(SsrDataContext);
}
